import { FC } from 'react';
import { Typography } from 'antd';
import { APPOINTMENT_CREATOR } from 'constants/appointments';

import { ICardNote } from './types';
import { StyledCard, NoteWrapper, Content, NoteInfo } from './styled';
import { getNoteText } from 'utils/getNoteText';

const { Title, Text, Paragraph } = Typography;

const CardNote: FC<ICardNote> = ({
  title,
  content,
  date,
  authorName,
  sender
}) => {
  // translations
  // const { t } = useTranslation();

  const isDoctor = sender === APPOINTMENT_CREATOR.doctor;

  return (
    <StyledCard>
      <Title
        level={5}
        style={{ marginBottom: 12, color: isDoctor ? '#6B7083' : '#0B1A30' }}
      >
        {title}
      </Title>
      <NoteWrapper isDoctor={isDoctor}>
        <Content>
          <Text>
            <span
              dangerouslySetInnerHTML={{ __html: getNoteText(content) }}
            ></span>
          </Text>
        </Content>
        <NoteInfo>
          <Text style={{ color: '#6B7083', margin: 0 }}>{authorName}</Text>
          <Paragraph
            style={{
              color: '#6B7083',
              margin: 0
            }}
          >
            {date}
          </Paragraph>
        </NoteInfo>
      </NoteWrapper>
    </StyledCard>
  );
};

export default CardNote;
